import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

export default {
    install(app, options) {
        const { router, env, dsn } = options

        if (!dsn) {
            return false
        }
        
        Sentry.init({
            dsn,
            Vue: app,
            enabled: env == 'prod',
            integrations: [
                new BrowserTracing({
                    routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                    tracePropagationTargets: ['shiftarcade.com', /^\//],
                    // The installed @sentry/tracing's bundled INP (Interaction to Next Paint)
                    // collector throws "Cannot read properties of undefined (reading
                    // 'startTime')" from its own getINP.js on some interaction sequences, an
                    // upstream bug in that web-vitals copy, not anything in this app's own
                    // code. INP is the newest and least stable of the metrics it tracks;
                    // disabling only it keeps LCP/CLS/FID/TTFB reporting intact.
                    enableInp: false,
                }),
            ],
            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for performance monitoring.
            // We recommend adjusting this value in production
            tracesSampleRate: 1.0,
        })
    }
}